import Vue from "vue";
import Vuex from "vuex";
import { getPlanificacionAnualCharter, getPlanificacionSemanal, getDeclaracionPorNave, getServicios, getItinerarios, getPalletsCharter, getContainersCharter } from "@/constants/charter";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    // Paso 3
    dataDataTablePlanificacionAnual: [],
    dataDataTablePlanificacionAnualFiltrada: [],

    //******************************************************************
    //*********************planificacion semanal ***********************
    //******************************************************************

    psCharterData: [],
    psCharterDataDatatableGeneral: [],
    psCharterDataDatatableGeneralFiltrada: [],
    psCharterDataDatatableDetail: [],
    psCharterDataDatatableDetailFiltrada: [],
    psCharterShowDetail: false,
    psCharterCreateMode: false,
    psCharterCurrentRegion: [],
    psCharterCurrentWeek: 0,
    psCharterCurrentWeeks: [],
    psCharterListaClientes: [],
    psCharterListaPallets: [],
    psCharterListaEspecies: [],
    psCharterListaPuertos: [],
    psCharterFiltroClientes: [],
    psCharterFiltroPallets: [],
    psCharterFiltroEspecies: [],
    psCharterFiltroPods: [],
    psCharterFiltroRoutes: [],
    psCharterEditingRowIndex: null,
    psCharterWeeksTotals: {
      week1: [0, 0],
      week2: [0, 0],
      week3: [0, 0],
      week4: [0, 0],
      week5: [0, 0]
    },

    //******************************************************************
    // ***************************Servicios*****************************
    //******************************************************************
    charterDataDatatableServicios: [],
    charterDataDatatableFiltradaServicios: [],
    charterAddingPortsServicios: false,
    charterCreateModeServiciosCharter: false,
    charterCurrentServiceDataServicios: [],
    charterShowManageModalServiciosCharter: false,
    charterPortsListServicios: [],
    charterStatusFilterServicios: [],

    // Servicios
    dataDatatableServiciosCharter: [],
    dataDatatableServiciosCharterFiltrada: [],

    visibleModalEditarServicioCharter: [],
    visibleModalEditarServicioPuertoCharter: [],

    // Itinerarios
    dataDatatableItinerariosPublicadosCharter: [],
    dataDatatableItinerariosPublicadosCharterFiltrada: [],
    dataDatatableItinerariosNoPublicadosCharter: [],
    dataDatatableItinerariosNoPublicadosCharterFiltrada: [],

    visibleModalEditarItinerarioPublicadoCharter: [],
    visibleModalEditarItinerarioNoPublicadoCharter: [],

    visibleModalEditarItinerarioPuertoCargaCharter: [],
    visibleModalEditarItinerarioPuertoDescargaCharter: [],
    visibleModalEditarItinerarioTransbordoCharter: [],
    visibleModalEditarItinerarioPuertoTransbordoCharter: [],

    // Listas para select
    listaAnios: [],
    listaPallet: [],
    listaRegiones: [],
    listaClientes: [],
    listaExportadores: [],
    listaPOL: [],
    listaPOD: [],
    listaTipoPallets: [],
    listaEspecies: [],
    listaCondiciones: [],




    // 

    dataAnioSeleccionado: [],
    checkPlanificacionAnual: [],


    // Planificaciones
    nuevosPlanificacionAnualMultiple: [],
    annualPlanId: '',

    puertosSeleccionadosPlanAnual: {
      tab_1: false,
      tab_2: false,
      tab_3: false,
      tab_4: false,
      tab_5: false,
    },

    paShowReportModal: false,


    dataDataTableDeclaracionPorNave: [],
    dataDataTableDeclaracionPorNaveFiltrada: [],
    showModalAgregarCargaNavesDeclaradas: false,
    showModalAgregarCargaBajoCubierta: { tipo: '', estado: false },
    showModalAgregarCargaSobreCubierta: { tipo: '', estado: false },

    showModalEditarDeclaracionFinalizadaPallets: false,
    showModalEditarDeclaracionFinalizadaContainers: false,

    showModalFinalizarPallets: false,

    //******************************************************************
    // **************************Itinerarios****************************
    //******************************************************************
    charterDataDatatableItinerarios: [],
    charterDataDatatableItinerariosFiltrada: [],
    charterShowManageModalItinerarios: false,
    charterCreateModeItinerarios: false,
    //listas
    charterPortsListItinerarios: [],
    charterNavierasListItinerarios: [],
    charterNavesListItinerarios: [],
    charterServiciosListItinerarios: [],
    //filtros
    charterNavierasFilterItinerarios: [],
    charterNavesFilterItinerarios: [],
    charterServiciosFilterItinerarios: [],
    charterSemanasFilterItinerarios: [],
    charterYearsFilterItinerarios: [],
    //
    charterAddingPOLsItinerarios: false,
    charterAddingPODsItinerarios: false,
    charterDataDatatablePOLsItinerarios: [],
    charterPOLsItinerarios: [],
    charterDataDatatablePODsItinerarios: [],
    charterPODsItinerarios: [],
    charterIsServicePODsItinerarios: false,
    charterCurrentItineraryData: [],
    charterDataDatatableBuscarItinerarios: [],

    // Pallets
    dataDatatablePalletsCharter: [],
    dataDatatablePalletsCharterFiltrada: [],
    id_charter_itinerary: null,
    filaSeleccionadaPallets: [],
    dataPalletFinished: [],
    // Containers
    dataDatatableContainersCharter: [],
    dataDatatableContainersCharterFiltrada: [],

    listaContainers: [],
    listaAtmosferas: [],
    listaZonasConsolidacion: [],
    listaMovementTypes: [],
    listaUnidadMedida: [],
    listaPorts: [],

    showModalFinalizarContainers: false,
    filaSeleccionadaContainers: [],

    //No finalizados Pallets
    navieraFilterFinalizados: [],
    routeFilterFinalizados: [],
    yearFilterFinalizados: [],
    weekFilterFinalizados: [],

    navieraFilterFinalizadosContainers: [],
    routeFilterFinalizadosContainers: [],
    yearFilterFinalizadosContainers: [],
    weekFilterFinalizadosContainers: [],

    dataContainersFinalizados: [],

    formPalletFinalizados: null,
    formContainerFinalizados: null,

    filterNaviera: [],
    filterRutas: [],
    filterShip: [],
    filterSemanas: [],
    filterAnios: [],

    dataTableCharterSI: [],
    dataDeclaracionPorNave: [],
    loadingDeclaracionNaves: false,
    dataTablePorEnviar: [],
    showModalDetalleSiPorEnviar: false,
    showModalEditarSiPorEnviar: false,
    loadTableSiPorEnviar: false,
    //
    dataTableCharterSITemplates: [],
  },

  // Paso 2
  mutations: {

    setDataDataTablePlanificacionAnual(state, payload) {
      state.dataDataTablePlanificacionAnual = payload;
      state.dataDataTablePlanificacionAnualFiltrada = payload;
    },

    setFilterDataDataTablePlanificacionAnual(state, payload) {
      state.dataDataTablePlanificacionAnual = payload;
      // state.dataDataTablePlanificacionAnualFiltrada = payload;
    },

    setlimpiarDataDataTablePlanificacionAnual(state) {
      state.dataDataTablePlanificacionAnualFiltrada = state.dataDataTablePlanificacionAnual;
    },

    //******************************************************************
    //*********************planificacion semanal ***********************
    //******************************************************************

    async setDataPSCharter(state) {
      state.psCharterData = await getPlanificacionSemanal();
      state.psCharterEditingRowIndex = null;
    },

    setEditingRowIndexPSCharter(state, payload) {
      state.psCharterEditingRowIndex = payload;
    },

    setDataDatatableGeneralPSCharter(state, payload) {
      state.psCharterDataDatatableGeneral = payload;
    },

    setDataDatatableGeneralFiltradaPSCharter(state, payload) {
      state.psCharterDataDatatableGeneralFiltrada = payload;
    },

    setDataDatatableGeneralNoFiltradaPSCharter(state) {
      state.psCharterDataDatatableGeneralFiltrada = state.psCharterDataDatatableGeneral;
    },

    setDataDatatableDetailPSCharter(state, payload) {
      state.psCharterDataDatatableDetail = payload;
    },

    setDataDatatableDetailFiltradaPSCharter(state, payload) {
      state.psCharterDataDatatableDetailFiltrada = payload;
    },

    setDataDatatableDetailNoFiltradaPSCharter(state) {
      state.psCharterDataDatatableDetailFiltrada = state.psCharterDataDatatableDetail;
    },

    setCurrentRegionPSCharter(state, payload) {
      state.psCharterCurrentRegion = payload;
    },

    setCurrentWeekPSCharter(state, payload) {
      state.psCharterCurrentWeek = payload;
    },

    setWeeksTotalsPSCharter(state, payload) {
      state.psCharterWeeksTotals = payload;
    },

    setCurrentWeeksPSCharter(state, payload) {
      state.psCharterCurrentWeeks = payload;
    },

    setListaClientesPSCharter(state, payload) {
      state.psCharterListaClientes = payload;
    },

    setListaPalletsPSCharter(state, payload) {
      state.psCharterListaPallets = payload;
    },

    setListaEspeciesPSCharter(state, payload) {
      state.psCharterListaEspecies = payload;
    },

    setListaPuertosPSCharter(state, payload) {
      state.psCharterListaPuertos = payload;
    },

    setFiltroClientesPSCharter(state, payload) {
      state.psCharterFiltroClientes = payload;
    },

    setFiltroPalletsPSCharter(state, payload) {
      state.psCharterFiltroPallets = payload;
    },

    setFiltroEspeciesPSCharter(state, payload) {
      state.psCharterFiltroEspecies = payload;
    },

    setFiltroPodsPSCharter(state, payload) {
      state.psCharterFiltroPods = payload;
    },

    setFiltroRoutesPSCharter(state, payload) {
      state.psCharterFiltroRoutes = payload;
    },

    setShowDetailPSCharter(state, payload) {
      state.psCharterShowDetail = payload;
    },

    setCreateModePSCharter(state, payload) {
      state.psCharterCreateMode = payload;
    },

    //******************************************************************
    //******************Servicios***************************************
    //******************************************************************

    setShowManageModalServiciosCharter(state, payload) {
      state.charterShowManageModalServiciosCharter = payload;
    },

    setCreateModeServiciosCharter(state, payload) {
      state.charterCreateModeServiciosCharter = payload;
    },

    async setDataDatatableServiciosCharter(state) {
      state.charterDataDatatableServicios = await getServicios();
    },

    setDataDatatableFiltradaServiciosCharter(state, payload) {
      state.charterDataDatatableFiltradaServicios = payload;
    },

    setDataDatatableNoFiltradaServiciosCharter(state) {
      state.charterDataDatatableFiltradaServicios = state.charterDataDatatableServicios;
    },

    setAddingPortsServiciosCharter(state, payload) {
      state.charterAddingPortsServicios = payload;
    },

    setPortsListServiciosCharter(state, payload) {
      state.charterPortsListServicios = payload;
    },

    setStatusFilterServiciosCharter(state, payload) {
      state.charterStatusFilterServicios = payload;
    },

    setCurrentServiceDataServiciosCharter(state, payload) {
      state.charterCurrentServiceDataServicios = payload;
    },


    setListaAnios(state, payload) {
      state.listaAnios = payload;
    },

    setListaPallet(state, payload) {
      state.listaPallet = payload;
    },

    setDataAnioSeleccionado(state, payload) {
      state.dataAnioSeleccionado = payload;
    },

    setNuevosPlanificacionAnualMultiple(state, payload) {
      state.nuevosPlanificacionAnualMultiple = payload;
    },

    setAnnualPlanId(state, payload) {
      state.annualPlanId = payload;
    },

    setCheckPlanificacionAnual(state, payload) {
      state.checkPlanificacionAnual = payload;
    },

    setClearCheckPlanificacionAnual(state) {
      state.checkPlanificacionAnual = [];
    },

    setPuertosSeleccionadosPlanAnual(state, payload) {

      let dataAux = state.puertosSeleccionadosPlanAnual;
      state.puertosSeleccionadosPlanAnual = [];

      let { id_tab, estado } = payload;

      state.puertosSeleccionadosPlanAnual = dataAux;

      switch (id_tab) {

        case 1:
          state.puertosSeleccionadosPlanAnual.tab_1 = estado;
          break;

        case 2:
          state.puertosSeleccionadosPlanAnual.tab_2 = estado;
          break;

        case 3:
          state.puertosSeleccionadosPlanAnual.tab_3 = estado;
          break;

        case 4:
          state.puertosSeleccionadosPlanAnual.tab_4 = estado;
          break;

        case 5:
          state.puertosSeleccionadosPlanAnual.tab_5 = estado;
          break;

      }

    },

    async setDataPlanificacionAnualTabla(state) {
      const sql = await getPlanificacionAnualCharter();
      state.dataDataTablePlanificacionAnual = sql;
      state.dataDataTablePlanificacionAnualFiltrada = sql;
    },

    setListaRegiones(state, payload) {
      state.listaRegiones = payload;
    },

    setListaClientes(state, payload) {
      state.listaClientes = payload;
    },
    setListaExportadores(state, payload) {
      state.listaExportadores = payload;
    },
    setListaPOL(state, payload) {
      state.listaPOL = payload;
    },
    setListaPOD(state, payload) {
      state.listaPOD = payload;
    },
    setListaTipoPallets(state, payload) {
      state.listaTipoPallets = payload;
    },
    setListaEspecies(state, payload) {
      state.listaEspecies = payload;
    },
    setListaCondiciones(state, payload) {
      state.listaCondiciones = payload;
    },

    setPAShowReportModal(state, payload) {
      state.paShowReportModal = payload;
    },

    async setDataDeclaracionPorNaveTabla(state) {
      const sql = await getDeclaracionPorNave();
      state.dataDataTableDeclaracionPorNave = sql;
      state.dataDataTableDeclaracionPorNaveFiltrada = sql;
    },

    setDataDeclaracionPorNaveTablafiltro(state, payload) {
      state.dataDataTableDeclaracionPorNave = payload.data;
      state.dataDataTableDeclaracionPorNaveFiltrada = payload.data;
    },

    setShowModalAgregarCargaNavesDeclaradas(state, payload) {
      state.showModalAgregarCargaNavesDeclaradas = payload;
    },

    setShowModalAgregarCargaBajoCubierta(state, payload) {
      state.showModalAgregarCargaBajoCubierta = payload;
    },

    setShowModalAgregarCargaSobreCubierta(state, payload) {
      state.showModalAgregarCargaSobreCubierta = payload;
    },

    setShowModalEditarDeclaracionFinalizadaPallets(state, payload) {
      state.showModalEditarDeclaracionFinalizadaPallets = payload;
    },

    setShowModalEditarDeclaracionFinalizadaContainers(state, payload) {
      state.showModalEditarDeclaracionFinalizadaContainers = payload;
    },

    setShowModalFinalizarPallets(state, payload) {
      state.showModalFinalizarPallets = payload;
    },

    //******************************************************************
    //**************************** Itinerarios**************************
    //******************************************************************

    setShowManageModalItinerariosCharter(state, payload) {
      state.charterShowManageModalItinerarios = payload;
    },

    setCreateModeItinerariosCharter(state, payload) {
      state.charterCreateModeItinerarios = payload;
    },

    async setDataDatatableItinerariosCharter(state) {
      state.charterDataDatatableItinerarios = await getItinerarios();
    },

    setDataDatatableFiltradaItinerariosCharter(state, payload) {
      state.charterDataDatatableItinerariosFiltrada = payload;
    },

    setDataDatatableNoFiltradaItinerariosCharter(state) {
      state.charterDataDatatableItinerariosFiltrada = state.charterDataDatatableItinerarios;
    },

    //listas
    setPortsListItinerariosCharter(state, payload) {
      state.charterPortsListItinerarios = payload;
    },

    setNavierasListItinerariosCharter(state, payload) {
      state.charterNavierasListItinerarios = payload;
    },

    setNavesListItinerariosCharter(state, payload) {
      state.charterNavesListItinerarios = payload;
    },

    setServiciosListItinerariosCharter(state, payload) {
      state.charterServiciosListItinerarios = payload;
    },

    //filtros
    setNavierasFilterItinerariosCharter(state, payload) {
      state.charterNavierasFilterItinerarios = payload;
    },

    setNavesFilterItinerariosCharter(state, payload) {
      state.charterNavesFilterItinerarios = payload;
    },

    setServiciosFilterItinerariosCharter(state, payload) {
      state.charterServiciosFilterItinerarios = payload;
    },

    setSemanasFilterItinerariosCharter(state, payload) {
      state.charterSemanasFilterItinerarios = payload;
    },

    setYearsFilterItinerariosCharter(state, payload) {
      state.charterYearsFilterItinerarios = payload;
    },

    setAddingPOLsItinerariosCharter(state, payload) {
      state.charterAddingPOLsItinerarios = payload;
    },

    setAddingPODsItinerariosCharter(state, payload) {
      state.charterAddingPODsItinerarios = payload;
    },

    setDataDatatablePOLsItinerariosCharter(state, payload) {
      state.charterDataDatatablePOLsItinerarios = payload;
    },

    setDataDatatablePODsItinerariosCharter(state, payload) {
      state.charterDataDatatablePODsItinerarios = payload;
    },

    setIsServicePODsItinerariosCharter(state, payload) {
      state.charterIsServicePODsItinerarios = payload;
    },

    setPODsItinerariosCharter(state, payload) {
      state.charterPODsItinerarios = payload;
    },

    setPOLsItinerariosCharter(state, payload) {
      state.charterPOLsItinerarios = payload;
    },

    setCurrentItineraryDataItinerariosCharter(state, payload) {
      state.charterCurrentItineraryData = payload;
    },

    setDataDatatableBuscarItinerariosCharter(state, payload) {
      state.charterDataDatatableBuscarItinerarios = payload;
    },

    async setDatatablePalletsCharter(state, payload) {

      const sql = await getPalletsCharter(payload);

      const { data: { pallets, filters: { clients, conditions, pallets: tipo_pallets, pods, pols, products } } } = sql;

      state.dataDatatablePalletsCharter = pallets;
      state.dataDatatablePalletsCharterFiltrada = pallets;

      state.listaClientes = clients;
      state.listaExportadores = "";
      state.listaPOL = pols;
      state.listaPOD = pods;
      state.listaTipoPallets = tipo_pallets;
      state.listaEspecies = products;
      state.listaCondiciones = conditions;

    },

    setDataIdCharterItinerary(state, payload) {
      state.id_charter_itinerary = payload;
    },

    setDataFilaSeleccionadaPallets(state, payload) {
      state.filaSeleccionadaPallets = payload;
    },
    setDataPalletFinished(state, payload) {
      state.dataPalletFinished = payload;
    },

    async setDatatableContainersCharter(state, payload) {

      const sql = await getContainersCharter(payload);

      const { data: { containers, filters: { clients, pods, pols, ports, products, conditions, containers: containers_tipos, atmospheres, consolidationZones, movementTypes, unidadMedida } } } = sql;

      state.dataDatatableContainersCharter = containers;
      state.dataDatatableContainersCharterFiltrada = containers;

      state.listaClientes = clients;
      state.listaEspecies = products;
      state.listaPOD = pods;
      state.listaPOL = pols;
      state.listaPorts = ports;
      state.listaCondiciones = conditions;

      state.listaContainers = containers_tipos;
      state.listaAtmosferas = atmospheres;
      state.listaZonasConsolidacion = consolidationZones;
      state.listaMovementTypes = movementTypes;
      state.listaUnidadMedida = unidadMedida;

    },

    setShowModalFinalizarContainers(state, payload) {
      state.showModalFinalizarContainers = payload;
    },

    setDataFilaSeleccionadaContainers(state, payload) {
      state.filaSeleccionadaContainers = payload;
    },
    setNavieraFilterFinalizados(state, payload) {
      state.navieraFilterFinalizados = payload;
    },
    setRouteFilterFinalizados(state, payload) {
      state.routeFilterFinalizados = payload;
    },
    setYearFilterFinalizados(state, payload) {
      state.yearFilterFinalizados = payload;
    },
    setWeekFilterFinalizados(state, payload) {
      state.weekFilterFinalizados = payload;
    },

    setNavieraFilterFinalizadosContainers(state, payload) {
      state.navieraFilterFinalizadosContainers = payload;
    },
    setRouteFilterFinalizadosContainers(state, payload) {
      state.routeFilterFinalizadosContainers = payload;
    },
    setYearFilterFinalizadosContainers(state, payload) {
      state.yearFilterFinalizadosContainers = payload;
    },
    setWeekFilterFinalizadosContainers(state, payload) {
      state.weekFilterFinalizadosContainers = payload;
    },
    setDataContainersFinalizados(state, payload) {
      state.dataContainersFinalizados = payload;
    },
    setFormPalletFinalizados(state, payload) {
      state.formPalletFinalizados = payload;
    },
    setFormContainerFinalizados(state, payload) {
      state.formContainerFinalizados = payload;
    },
    setDataFilterNaviera(state, payload) {
      state.filterNaviera = payload;
    },
    setDataFilterRutas(state, payload) {
      state.filterRutas = payload;
    },
    setDataFilterShip(state, payload) {
      state.filterShip = payload;
    },
    setDataFilterSemanas(state, payload) {
      state.filterSemanas = payload;
    },
    setDataFilterAnios(state, payload) {
      state.filterAnios = payload;
    },
    setDataDeclaracionPorNave(state, payload) {
      state.dataDeclaracionPorNave = payload;
    },
    setLoadingDeclaracionNaves(state, payload) {
      state.loadingDeclaracionNaves = payload;
    },
    setDataTableCharterSI(state, payload) {
      state.dataTableCharterSI = payload;
    },
    setDataTablePorEnviar(state, payload) {
      state.dataTablePorEnviar = payload;
    },
    setDataTableCharterSITemplates(state, payload) {
      state.dataTableCharterSITemplates = payload;
    },
    setShowModalDetalleSiPorEnviar(state, payload) {
      state.showModalDetalleSiPorEnviar = payload;
    },
    setShowModalEditarSiPorEnviar(state, payload) {
      state.showModalEditarSiPorEnviar = payload;
    },
    setLoadTableSiPorEnviar(state, payload) {
      state.loadTableSiPorEnviar = payload;
    },
  },

  // Paso 1
  //********************************** Plan Anual *******************************


  actions: {

    actionSetDataDataTablePlanificacionAnualCharter({ commit }, data) {
      commit("setDataDataTablePlanificacionAnualCharter", data);
    },

    actionSetFilterDataDataTablePlanificacionAnualCharter({ commit }, data) {
      commit("setFilterDataDataTablePlanificacionAnualCharter", data);
    },

    actionSetLimpiarDataDataTablePlanificacionAnualCharter({ commit }) {
      commit("setlimpiarDataDataTablePlanificacionAnualCharter");
    },

    actionSetVisibleModalEditarItinerarioPuertoDescargaCharter({ commit }, data) {
      commit("setVisibleModalEditarItinerarioPuertoDescargaCharter", data);
    },

    actionSetCreateModeServiciosCharter({ commit }, data) {
      commit("setCreateModeServiciosCharter", data);
    },

    actionSetListaPallet({ commit }, data) {
      commit("setListaPallet", data);
    },

    actionResetDataAnioSeleccionado({ commit }) {
      commit('setDataAnioSeleccionado', []);
    },

    actionSetPuertosSeleccionadosPlanAnual({ commit }, data) {
      commit('setPuertosSeleccionadosPlanAnual', data);
    },

    actionSetDataPlanificacionAnualTabla({ commit }) {
      commit("setDataPlanificacionAnualTabla");
    },

    actionSetListaRegiones({ commit }, data) {
      commit("setListaRegiones", data);
    },

    actionSetListaClientes({ commit }, data) {
      commit("setListaClientes", data);
    },
    actionSetListaExportadores({ commit }, data) {
      commit("setListaExportadores", data);
    },
    actionSetListaPOL({ commit }, data) {
      commit("setListaPOL", data);
    },
    actionSetListaPOD({ commit }, data) {
      commit("setListaPOD", data);
    },
    actionSetListaTipoPallets({ commit }, data) {
      commit("setListaTipoPallets", data);
    },
    actionSetListaEspecies({ commit }, data) {
      commit("setListaEspecies", data);
    },
    actionSetListaCondiciones({ commit }, data) {
      commit("setListaCondiciones", data);
    },

    actionSetPAShowReportModal({ commit }, data) {
      commit("setPAShowReportModal", data);
    },

    //******************************************************************
    //*********************planificacion semanal ***********************
    //******************************************************************

    actionSetDataPSCharter({ commit }, data) {
      commit("setDataPSCharter", data);
    },

    actionSetEditingRowIndexPSCharter({ commit }, data) {
      commit("setEditingRowIndexPSCharter", data);
    },

    actionSetDataDatatableGeneralPSCharter({ commit }, data) {
      commit("setDataDatatableGeneralPSCharter", data);
    },

    actionSetDataDatatableGeneralFiltradaPSCharter({ commit }, data) {
      commit("setDataDatatableGeneralFiltradaPSCharter", data);
    },

    actionSetDataDatatableGeneralNoFiltradaPSCharter({ commit }, data) {
      commit("setDataDatatableGeneralNoFiltradaPSCharter", data);
    },

    actionSetDataDatatableDetailPSCharter({ commit }, data) {
      commit("setDataDatatableDetailPSCharter", data);
    },

    actionSetDataDatatableDetailFiltradaPSCharter({ commit }, data) {
      commit("setDataDatatableDetailFiltradaPSCharter", data);
    },

    actionSetDataDatatableDetailNoFiltradaPSCharter({ commit }, data) {
      commit("setDataDatatableDetailNoFiltradaPSCharter", data);
    },

    actionSetCurrentRegionPSCharter({ commit }, data) {
      commit("setCurrentRegionPSCharter", data);
    },

    actionSetCurrentWeekPSCharter({ commit }, data) {
      commit("setCurrentWeekPSCharter", data);
    },

    actionSetCurrentWeeksPSCharter({ commit }, data) {
      commit("setCurrentWeeksPSCharter", data);
    },

    actionSetListaClientesPSCharter({ commit }, data) {
      commit("setListaClientesPSCharter", data);
    },

    actionSetListaPalletsPSCharter({ commit }, data) {
      commit("setListaPalletsPSCharter", data);
    },

    actionSetListaEspeciesPSCharter({ commit }, data) {
      commit("setListaEspeciesPSCharter", data);
    },

    actionSetListaPuertosPSCharter({ commit }, data) {
      commit("setListaPuertosPSCharter", data);
    },

    actionSetFiltroPodsPSCharter({ commit }, data) {
      commit("setFiltroPodsPSCharter", data);
    },

    actionSetFiltroClientesPSCharter({ commit }, data) {
      commit("setFiltroClientesPSCharter", data);
    },

    actionSetFiltroPalletsPSCharter({ commit }, data) {
      commit("setFiltroPalletsPSCharter", data);
    },

    actionSetFiltroEspeciesPSCharter({ commit }, data) {
      commit("setFiltroEspeciesPSCharter", data);
    },

    actionSetFiltroRoutesPSCharter({ commit }, data) {
      commit("setFiltroRoutesPSCharter", data);
    },

    actionSetShowDetailPSCharter({ commit }, data) {
      commit("setShowDetailPSCharter", data);
    },

    actionSetCreateModePSCharter({ commit }, data) {
      commit("setCreateModePSCharter", data);
    },

    actionSetWeeksTotalsPSCharter({ commit }, data) {
      commit("setWeeksTotalsPSCharter", data);
    },

    //******************************************************************
    //***********************Servicios**********************************
    //******************************************************************

    actionSetDataDatatableServiciosCharter({ commit }, data) {
      commit("setDataDatatableServiciosCharter", data);
    },

    actionSetDataDatatableFiltradaServiciosCharter({ commit }, data) {
      commit("setDataDatatableFiltradaServiciosCharter", data);
    },

    actionSetDataDatatableNoFiltradaServiciosCharter({ commit }, data) {
      commit("setDataDatatableNoFiltradaServiciosCharter", data);
    },

    actionSetAddingPortsServiciosCharter({ commit }, data) {
      commit("setAddingPortsServiciosCharter", data);
    },

    actionSetPortsListServiciosCharter({ commit }, data) {
      commit("setPortsListServiciosCharter", data);
    },

    actionSetStatusFilterServiciosCharter({ commit }, data) {
      commit("setStatusFilterServiciosCharter", data);
    },

    actionSetCurrentServiceDataServiciosCharter({ commit }, data) {
      commit("setCurrentServiceDataServiciosCharter", data);
    },

    actionSetShowManageModalServiciosCharter({ commit }, data) {
      commit("setShowManageModalServiciosCharter", data);
    },

    actionSetVisibleModalEditarItinerarioTransbordoCharter({ commit }, data) {
      commit("setVisibleModalEditarItinerarioTransbordoCharter", data);
    },

    actionSetVisibleModalEditarItinerarioPuertoTransbordoCharter({ commit }, data) {
      commit("setVisibleModalEditarItinerarioPuertoTransbordoCharter", data);
    },

    actionSetListaAnios({ commit }, data) {
      commit("setListaAnios", data);
    },

    actionSetDataAnioSeleccionado({ commit }, data) {
      commit('setDataAnioSeleccionado', data);
    },

    actionSetNuevosPlanificacionAnualMultiples({ commit }, data) {
      commit('setNuevosPlanificacionAnualMultiple', data);
    },

    actionSetAnnualPlanId({ commit }, data) {
      commit('setAnnualPlanId', data);
    },

    actionSetCheckPlanificacionAnual({ commit }, data) {
      commit('setCheckPlanificacionAnual', data);
    },

    actionSetClearCheckPlanificacionAnual({ commit }, data) {
      commit('setClearCheckPlanificacionAnual', data);
    },

    actionSetFilterDataDataTablePlanificacionAnual({ commit }, data) {
      commit("setFilterDataDataTablePlanificacionAnual", data);
    },

    //******************************************************************
    //************************** Itinerarios****************************
    //******************************************************************

    actionSetDataDatatableItinerariosCharter({ commit }, data) {
      commit("setDataDatatableItinerariosCharter", data);
    },

    actionSetDataDatatableFiltradaItinerariosCharter({ commit }, data) {
      commit("setDataDatatableFiltradaItinerariosCharter", data);
    },

    actionSetDataDeclaracionPorNaveTabla({ commit }) {
      commit("setDataDeclaracionPorNaveTabla");
    },

    actionSetDataDeclaracionPorNaveTablafiltro({ commit }, data) {
      commit("setDataDeclaracionPorNaveTablafiltro", data);
    },

    actionSetShowModalAgregarCargaNavesDeclaradas({ commit }, data) {
      commit("setShowModalAgregarCargaNavesDeclaradas", data);
    },

    actionSetShowModalAgregarCargaBajoCubierta({ commit }, data) {
      commit("setShowModalAgregarCargaBajoCubierta", data);
    },

    actionSetShowModalAgregarCargaSobreCubierta({ commit }, data) {
      commit("setShowModalAgregarCargaSobreCubierta", data);
    },

    actionSetShowModalEditarDeclaracionFinalizadaPallets({ commit }, data) {
      commit("setShowModalEditarDeclaracionFinalizadaPallets", data);
    },

    actionSetShowModalEditarDeclaracionFinalizadaContainers({ commit }, data) {
      commit("setShowModalEditarDeclaracionFinalizadaContainers", data);
    },

    actionSetShowModalFinalizarPallets({ commit }, data) {
      commit("setShowModalFinalizarPallets", data);
    },

    actionSetDataDatatableNoFiltradaItinerariosCharter({ commit }, data) {
      commit("setDataDatatableNoFiltradaItinerariosCharter", data);
    },

    actionSetCreateModeItinerariosCharter({ commit }, data) {
      commit("setCreateModeItinerariosCharter", data);
    },

    actionSetShowManageModalItinerariosCharter({ commit }, data) {
      commit("setShowManageModalItinerariosCharter", data);
    },

    //listas
    actionSetPortsListItinerariosCharter({ commit }, data) {
      commit("setPortsListItinerariosCharter", data);
    },

    actionSetNavesListItinerariosCharter({ commit }, data) {
      commit("setNavesListItinerariosCharter", data);
    },

    actionSetNavierasListItinerariosCharter({ commit }, data) {
      commit("setNavierasListItinerariosCharter", data);
    },

    actionSetServiciosListItinerariosCharter({ commit }, data) {
      commit("setServiciosListItinerariosCharter", data);
    },

    //filtros
    actionSetNavierasFilterItinerariosCharter({ commit }, data) {
      commit("setNavierasFilterItinerariosCharter", data);
    },

    actionSetNavesFilterItinerariosCharter({ commit }, data) {
      commit("setNavesFilterItinerariosCharter", data);
    },

    actionSetServiciosFilterItinerariosCharter({ commit }, data) {
      commit("setServiciosFilterItinerariosCharter", data);
    },

    actionSetSemanasFilterItinerariosCharter({ commit }, data) {
      commit("setSemanasFilterItinerariosCharter", data);
    },

    actionSetYearsFilterItinerariosCharter({ commit }, data) {
      commit("setYearsFilterItinerariosCharter", data);
    },

    //
    actionSetAddingPOLsItinerariosCharter({ commit }, data) {
      commit("setAddingPOLsItinerariosCharter", data);
    },

    actionSetAddingPODsItinerariosCharter({ commit }, data) {
      commit("setAddingPODsItinerariosCharter", data);
    },

    actionSetDataDatatablePOLsItinerariosCharter({ commit }, data) {
      commit("setDataDatatablePOLsItinerariosCharter", data);
    },

    actionSetDataDatatablePODsItinerariosCharter({ commit }, data) {
      commit("setDataDatatablePODsItinerariosCharter", data);
    },

    actionSetIsServicePODsItinerariosCharter({ commit }, data) {
      commit("setIsServicePODsItinerariosCharter", data);
    },

    actionSetPODsItinerariosCharter({ commit }, data) {
      commit("setPODsItinerariosCharter", data);
    },

    actionSetPOLsItinerariosCharter({ commit }, data) {
      commit("setPOLsItinerariosCharter", data);
    },

    actionSetCurrentItineraryDataItinerariosCharter({ commit }, data) {
      commit("setCurrentItineraryDataItinerariosCharter", data);
    },

    actionSetDataDatatableBuscarItinerariosCharter({ commit }, data) {
      commit("setDataDatatableBuscarItinerariosCharter", data);
    },

    actionSetDatatablePalletsCharter({ commit }, data) {
      commit("setDatatablePalletsCharter", data);
    },

    actionSetDataIdCharterItinerary({ commit }, data) {
      commit("setDataIdCharterItinerary", data);
    },

    actionSetDataFilaSeleccionadaPallets({ commit }, data) {
      commit("setDataFilaSeleccionadaPallets", data);
    },

    actionSetDatatableContainersCharter({ commit }, data) {
      commit("setDatatableContainersCharter", data);
    },
    actionSetDataPalletFinished({ commit }, data) {
      commit("setDataPalletFinished", data);
    },

    actionSetShowModalFinalizarContainers({ commit }, data) {
      commit("setShowModalFinalizarContainers", data);
    },

    actionSetDataFilaSeleccionadaContainers({ commit }, data) {
      commit("setDataFilaSeleccionadaContainers", data);
    },
    actionSetNavieraFilterFinalizados({ commit }, data) {
      commit("setNavieraFilterFinalizados", data);
    },
    actionSetRouteFilterFinalizados({ commit }, data) {
      commit("setRouteFilterFinalizados", data);
    },
    actionSetYearFilterFinalizados({ commit }, data) {
      commit("setYearFilterFinalizados", data);
    },
    actionSetWeekFilterFinalizados({ commit }, data) {
      commit("setWeekFilterFinalizados", data);
    },
    actionSetNavieraFilterFinalizadosContainers({ commit }, data) {
      commit("setNavieraFilterFinalizadosContainers", data);
    },
    actionSetRouteFilterFinalizadosContainers({ commit }, data) {
      commit("setRouteFilterFinalizadosContainers", data);
    },
    actionSetYearFilterFinalizadosContainers({ commit }, data) {
      commit("setYearFilterFinalizadosContainers", data);
    },
    actionSetWeekFilterFinalizadosContainers({ commit }, data) {
      commit("setWeekFilterFinalizadosContainers", data);
    },
    actionSetDataContainersFinalizados({ commit }, data) {
      commit("setDataContainersFinalizados", data);
    },
    actionSetFormPalletFinalizados({ commit }, data) {
      commit("setFormPalletFinalizados", data);
    },
    actionSetFormContainerFinalizados({ commit }, data) {
      commit("setFormContainerFinalizados", data);
    },

    actionSetDataFilterNaviera({ commit }, data) {
      commit("setDataFilterNaviera", data);
    },

    actionSetDataFilterRutas({ commit }, data) {
      commit("setDataFilterRutas", data);
    },

    actionSetDataFilterShip({ commit }, data) {
      commit("setDataFilterShip", data);
    },

    actionSetDataFilterSemanas({ commit }, data) {
      commit("setDataFilterSemanas", data);
    },

    actionSetDataFilterAnios({ commit }, data) {
      commit("setDataFilterAnios", data);
    },
    actionSetDataDeclaracionPorNave({ commit }, data) {
      commit("setDataDeclaracionPorNave", data);
    },
    actionSetLoadingDeclaracionNaves({ commit }, data) {
      commit("setLoadingDeclaracionNaves", data);
    },
    actionSetDataTablePorEnviar({ commit }, data) {
      commit("setDataTablePorEnviar", data);
    },

    actionSetDataTableCharterSI({ commit }, data) {
      commit("setDataTableCharterSI", data);
    },
    actionSetShowModalDetalleSiPorEnviar({ commit }, data) {
      commit("setShowModalDetalleSiPorEnviar", data);
    },
    actionSetShowModalEditarSiPorEnviar({ commit }, data) {
      commit("setShowModalEditarSiPorEnviar", data);
    },
    actionSetLoadTableSiPorEnviar({ commit }, data) {
      commit("setLoadTableSiPorEnviar", data);
    },

    //
    actionSetDataTableCharterSITemplates({ commit }, data) {
      commit("setDataTableCharterSITemplates", data);
    },
  }
};
